import { Component, inject, input, signal, computed, ChangeDetectionStrategy, type OnInit, type InputSignal, type WritableSignal, type Signal } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';
import { ModalService } from '../../modal.service';
import type { ModalRef } from '../../modal-ref';

@Component({
  selector: 'td-wb-modal-header-title',
  template: '<h2><span [translate]="modalTitle()" [translateParams]="modalTitleParams()"></span></h2>',
  styleUrls: ['modal-header-title.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateDirective],
  host: {
    '[attr.id]': 'id()'
  }
})
export class ModalHeaderTitleComponent implements OnInit {
  readonly modalTitle: InputSignal<string | undefined> = input<string>();
  readonly modalTitleParams: InputSignal<{[key: string]: string | number}> = input<{[key: string]: string | number}>({});

  private readonly modalService: ModalService = inject(ModalService);
  private readonly modalId: WritableSignal<string | undefined> = signal<string | undefined>(undefined);

  readonly id: Signal<string | undefined> = computed((): string | undefined => this.modalId() ? `${this.modalId()}-title` : undefined);

  // ModalRef instances are created dynamically and not available for constructor DI.
  // So deferring retrieving the most recent modal reference until after the component is initialized.
  ngOnInit(): void {
    const modal: ModalRef<unknown> = this.modalService.getTopModal();
    if (modal) {
      this.modalId.set(modal.id);
    }
  }
}
